<template>
  <div class="container-fluid mb-2" v-if="this.entityId">
    <d-row>
      <d-col class="col-table" v-if="!isCustomer">
        <table class="table mb-0 table-striped">
          <thead>
            <tr>
              <th scope="col" class="border-0 px-0 pb-0">
                Todos os {{ entityName }}
              </th>
            </tr>
            <div class="d-flex py-2">
              <slot
                name="filters"
                :paginationDetached="paginationDetached"
              ></slot>
              <form
                class="main-sidebar__search w-100 p-0 d-flex border rounded"
              >
                <input-search
                  :model.sync="paginationDetached.search"
                  id="input_detached_search"
                />
              </form>
            </div>
          </thead>
          <tbody class="border-left border-right row-table">
            <tr v-for="(row, index) in detachedDistributors.list" :key="index">
              <td
                class="d-flex justify-content-between align-content-center"
                :class="['td-4', isSelected(row) ? 'selected' : '']"
                @click="selectRow(row, 'attached')"
              >
                <span>{{ showItem(row) }}</span>
                <slot name="icon" :id="row.id"></slot>
              </td>
            </tr>
            <tr v-if="detachedDistributors.total_items === 0">
              <td class="no-content">
                {{
                  paginationDetached.search
                    ? 'Nenhum resultado encontrado para o termo pesquisado.'
                    : 'Nenhum item encontrado.'
                }}
              </td>
            </tr>
          </tbody>
          <pagination
            :total-items="detachedDistributors.total_items"
            :pagination.sync="paginationDetached"
            :eventName="'update:pagination_detached'"
          />
        </table>
      </d-col>
      <d-col
        cols="1"
        class="d-flex align-items-center justify-content-center"
        v-if="!isCustomer"
      >
        <d-button class="btn-outline-info btn-sm" @click="sync">
          <i class="material-icons">sync_alt</i>
        </d-button>
      </d-col>
      <d-col class="col-table">
        <table class="table mb-0 table-striped">
          <thead>
            <tr>
              <th scope="col" class="border-0 px-0 pb-0">
                {{ entityName }} Selecionados
              </th>
            </tr>
            <div class="d-flex py-2">
              <form
                class="main-sidebar__search w-100 p-0 d-flex border rounded"
              >
                <input-search
                  :model.sync="paginationAttached.search"
                  id="input_attached_search"
                />
              </form>
            </div>
          </thead>
          <tbody class="border-left border-right row-table">
            <tr
              v-for="(row, index) in attachedDistributors.list.slice(0, 10)"
              :key="index"
            >
              <td
                class="d-flex justify-content-between align-content-center"
                :class="['td-4', isSelected(row) ? 'selected' : '']"
                @click="selectRow(row, 'detached')"
              >
                <span>{{ showItem(row) }}</span>
                <slot name="icon" :id="row.id"></slot>
              </td>
            </tr>
            <tr v-if="attachedDistributors.total_items === 0">
              <td class="no-content">
                {{
                  paginationAttached.search
                    ? 'Nenhum resultado encontrado para o termo pesquisado.'
                    : 'Não há nenhum atribuído.'
                }}
              </td>
            </tr>
          </tbody>
          <pagination
            :total-items="attachedDistributors.total_items"
            :pagination.sync="paginationAttached"
            :eventName="'update:pagination_attached'"
          />
        </table>
      </d-col>
    </d-row>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import { compareObjects } from '_utils';
import Pagination from '_common/shared/Pagination.vue';
import InputSearch from '_shared/InputSearch.vue';

const ATTACHED = 'attached';
const DETACHED = 'detached';

export default {
  name: 'assignment',
  components: { Pagination, InputSearch },
  props: {
    entityName: {
      type: String,
      default: 'Distribuidores',
    },
    storeName: {
      type: String,
    },
    onShowText: {
      type: Function,
      default: null,
    },
    getAssociatedDistributors: {
      type: Function,
      default: () => {},
    },
    syncAttacherDistributors: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      type: ATTACHED,
      timer: null,
      entityId: null,
      selected: [],
      paginationDetached: {
        entityId: null,
        group: DETACHED,
        state: null,
        search: '',
        skip: 0,
        take: 10,
        page: 1,
      },
      paginationAttached: {
        entityId: null,
        group: ATTACHED,
        search: '',
        skip: 0,
        take: 10,
        page: 1,
      },
    };
  },
  computed: {
    detachedDistributors() {
      const { detachedDistributors } = this.$store.state[this.storeName];
      if (detachedDistributors) {
        return detachedDistributors;
      }
      return {
        list: [],
        total_items: 0,
      };
    },
    allAttachedDistributorsData() {
      const { allAttachedDistributors } = this.$store.state[this.storeName];
      if (allAttachedDistributors) {
        return allAttachedDistributors.list;
      }
      return {
        list: [],
        total_items: 0,
      };
    },
    attachedDistributors: {
      get() {
        const { attachedDistributors } = this.$store.state[this.storeName];

        if (attachedDistributors) {
          return attachedDistributors;
        }
        return { total_items: 0, list: [] };
      },
      set(attachedDistributor) {
        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
          this.syncAttacherDistributors({
            attachedDistributor,
            id: this.entityId,
          })
            .then(this.saveSuccess)
            .catch(this.saveError);
        }, 800);
      },
    },
    isCustomer() {
      const { user } = this.$store.state.user;
      if (user.settings.user_type_id === 3) {
        return true;
      }
      return false;
    },
  },
  methods: {
    ...mapActions(['activeAlert']),
    attach() {
      this.syncAttacherDistributors({
        attachedDistributor: this.prepareAttached(),
        id: this.entityId,
      })
        .then(this.saveSuccess)
        .catch(this.saveError);
    },
    detach() {
      this.syncAttacherDistributors({
        attachedDistributor: this.prepareDetached(),
        id: this.entityId,
      })
        .then(this.saveSuccess)
        .catch(this.saveError);
    },
    getDistributors() {
      this.getDistributorList(this.paginationDetached);
      this.getDistributorList({ ...this.paginationAttached, take: 0 });
    },
    getDistributorList(paginate) {
      this.getAssociatedDistributors({
        ...paginate,
        ...{ id: this.entityId },
      });
    },
    isSelected(row) {
      if (this.selected.includes(row)) {
        return true;
      }
      return false;
    },
    prepareAttached() {
      return this.allAttachedDistributorsData.concat(
        this.selected.map(row => row)
      );
    },
    prepareDetached() {
      return this.allAttachedDistributorsData.filter(
        row => !this.selected.some(selected => compareObjects(row, selected))
      );
    },
    reloadList(paginate) {
      if (paginate.search == null) {
        this.getDistributorList({
          ...paginate,
          page: 1,
          skip: 0,
          take: 10,
        });
        paginate.page = 1;
      } else {
        paginate.search = null;
      }
    },
    saveError(error) {
      this.activeAlert({
        message: `${error.message} <br/> ${error.data}`,
        theme: 'danger',
      });
    },
    saveSuccess() {
      this.selected = [];
      this.reloadList(this.paginationDetached);
      this.reloadList(this.paginationAttached);

      this.activeAlert({
        message: 'Sincronização salva com sucesso',
        theme: 'success',
      });
    },
    selectRow(row, type) {
      if (type !== this.type) {
        this.type = type;
        this.selected = [];
      }
      if (row.disabled) {
        return false;
      }
      const index = this.selected.indexOf(row);
      if (index > -1) {
        return this.selected.splice(index, 1);
      }
      return this.selected.push(row);
    },
    sync() {
      if (this.type === ATTACHED) {
        return this.attach();
      }
      return this.detach();
    },
    clear(pagination) {
      if (pagination === 'paginationDetached') {
        this.paginationDetached.search = '';
      } else {
        this.paginationAttached.search = '';
      }
    },
    showItem(item) {
      if (this.onShowText) {
        return this.onShowText(item);
      }
      return item.name;
    },
  },
  mounted() {
    this.entityId = parseInt(this.$route.params.id, Number);
    Events.$on('update:pagination_detached', pagination => {
      this.getDistributorList(pagination);
    });
    Events.$on('update:pagination_attached', pagination => {
      this.getDistributorList(pagination);
    });
    Events.$on('update:pagination_detached_some_attributes', attributes => {
      this.paginationDetached = { ...this.paginationDetached, ...attributes };
    });

    this.getDistributors();
  },
  destroyed() {
    Events.$off('update:pagination_detached');
    Events.$off('update:pagination_attached');
    Events.$off('update:pagination_detached_some_attributes');
  },
};
</script>

<style lang="scss" scoped>
@import '~_scss/overrides';

.row-table {
  border-radius: 0.3rem;
}

.table {
  border-radius: 0.3rem;
  .no-content {
    vertical-align: middle;
  }
  .selected {
    background: lighten($cyan, 45%);
  }
  &-sync {
    tr td {
      height: 47px;
    }
  }
}
.btn-outline-info {
  font-size: 1.4rem;
  padding: 0px 20px;
}
</style>
